import { Skeleton, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomDiv } from "@/common/divs";
import {
  AlmostBoldText,
  AlmostBoldNewLineText,
  LightTextSpan,
  RegularText,
} from "@/common/texts";
import { useFixHydration } from "@/hooks/useFixHydration";

const Slogan: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isSmallMobile = useMediaQuery("(max-width: 340px)");
  //getLanguage from url
  const { i18n } = useTranslation();
  const language = i18n.language;

  const mounted = useFixHydration();

  if (!mounted) {
    return <Skeleton variant="rounded" height={465}></Skeleton>;
  }

  return (
    isMobile ?
      language == "en" ?
        <CustomDiv style={{ textAlign: "left", paddingTop: "0px" }}>
          <AlmostBoldNewLineText
            fontSize="40px"
            style={{ lineHeight: isSmallMobile ? "60px" : "50px" }}
          >
            Vee <LightTextSpan color="#FFF7E4">adventurous, </LightTextSpan>
          </AlmostBoldNewLineText>
          <AlmostBoldNewLineText
            fontSize="40px"
            style={{
              lineHeight: isSmallMobile ? "60px" : "50px",
              marginLeft: "40px",
            }}
          >
            Vee <LightTextSpan color="#FFF7E4">a traveler, </LightTextSpan>
          </AlmostBoldNewLineText>
          <AlmostBoldNewLineText
            fontSize="40px"
            style={{
              lineHeight: isSmallMobile ? "60px" : "50px",
              marginLeft: "80px",
            }}
          >
            Vee <LightTextSpan color="#FFF7E4">alive</LightTextSpan>
          </AlmostBoldNewLineText>
          <RegularText style={{ textAlign: "center" }} fontSize="22px">
            {t("landing.scape")}
          </RegularText>
        </CustomDiv>
      : <CustomDiv style={{ textAlign: "left", paddingTop: "20px" }}>
          <AlmostBoldNewLineText fontSize="54px" style={{ lineHeight: "80px" }}>
            Sal <LightTextSpan color="#FFF7E4">más, </LightTextSpan>
          </AlmostBoldNewLineText>
          <AlmostBoldNewLineText
            fontSize="54px"
            style={{ lineHeight: "80px", marginLeft: "40px" }}
          >
            Ve <LightTextSpan color="#FFF7E4">más, </LightTextSpan>
          </AlmostBoldNewLineText>
          <AlmostBoldNewLineText
            fontSize="54px"
            style={{ lineHeight: "80px", marginLeft: "80px" }}
          >
            Vive <LightTextSpan color="#FFF7E4">más</LightTextSpan>
          </AlmostBoldNewLineText>
          <RegularText style={{ textAlign: "center" }} fontSize="22px">
            {t("landing.scape")}
          </RegularText>
        </CustomDiv>
    : language == "en" ?
      <>
        <CustomDiv style={{ paddingLeft: "80px", paddingRight: "80px" }}>
          <AlmostBoldText fontSize="54px">
            Vee <LightTextSpan color="#FFF7E4">adventurous, </LightTextSpan>Vee{" "}
            <LightTextSpan color="#FFF7E4">a traveler, </LightTextSpan>
          </AlmostBoldText>
          <AlmostBoldText
            fontSize="54px"
            style={{ lineHeight: "20px", marginTop: "-15px" }}
          >
            Vee <LightTextSpan color="#FFF7E4">alive</LightTextSpan>
          </AlmostBoldText>
          <RegularText style={{ textAlign: "center" }} fontSize="22px">
            {t("landing.scape")}
          </RegularText>
        </CustomDiv>
      </>
    : <>
        <CustomDiv>
          <AlmostBoldText fontSize="54px">
            Sal <LightTextSpan color="#FFF7E4">más, </LightTextSpan>Ve{" "}
            <LightTextSpan color="#FFF7E4">más </LightTextSpan>
          </AlmostBoldText>
          <AlmostBoldText
            fontSize="54px"
            style={{ lineHeight: "20px", marginTop: "-15px" }}
          >
            Vive <LightTextSpan color="#FFF7E4">más</LightTextSpan>
          </AlmostBoldText>
          <RegularText style={{ textAlign: "center" }} fontSize="22px">
            {t("landing.scape")}
          </RegularText>
        </CustomDiv>
      </>
  );
};

export default Slogan;
